$(document).ready(function(){
  
  $('.collection-slider-container').slick({
  infinite: true,
  arrows: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000, 
  responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        }
      }
    ],
  responsive: [
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        }
      }
    ]        
  });

  $('.blog-slider-container').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 700,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10%'
        }
      },
      {
        breakpoint: 1000,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3
        }
      }
    ]        
  });
  var ww = document.body.clientWidth;
  if(ww < 1080){
     $('.ino-collection-slider').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '10%'   
  });
  }
});
